import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function BMVInfo() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="footer-bmv-link"
        className="text-sm text-ink2 hover:text-ink underline-offset-4 hover:underline transition-colors"
      >
        BMV — Brasil Mata Viva
      </button>

      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center px-4 py-8 bg-ink/70 backdrop-blur-sm"
          onClick={() => setOpen(false)}
          data-testid="bmv-info-overlay"
        >
          <div
            className="relative w-full max-w-2xl bg-bg border border-ink shadow-2xl max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="border-b border-line px-6 py-4 flex items-center justify-between sticky top-0 bg-bg">
              <div>
                <div className="label-tag">{t("bmv.tag")}</div>
                <div className="font-serif text-2xl mt-1">{t("bmv.title")}</div>
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                data-testid="bmv-info-close"
                aria-label="Close"
                className="text-ink2 hover:text-ink text-2xl leading-none px-2"
              >
                ×
              </button>
            </div>

            <div className="px-6 py-6 space-y-5 text-sm text-ink2 leading-relaxed">
              <p>{t("bmv.intro")}</p>

              <div>
                <div className="label-tag mb-2">{t("bmv.protocols_h")}</div>
                <p>{t("bmv.protocols_p")}</p>
              </div>

              <div className="border border-line bg-surface p-4">
                <div className="font-serif text-ink text-lg">{t("bmv.ucs_h")}</div>
                <p className="mt-2">{t("bmv.ucs_p")}</p>
              </div>

              <div className="border border-line bg-surface p-4">
                <div className="font-serif text-ink text-lg">{t("bmv.science_h")}</div>
                <p className="mt-2">{t("bmv.science_p")}</p>
              </div>

              <a
                href="https://bmv.global"
                target="_blank"
                rel="noreferrer"
                data-testid="bmv-info-link-out"
                className="btn-primary !text-xs inline-block !px-5 !py-3 mt-2"
              >
                {t("bmv.visit")} ↗
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
